import React, { useState, useEffect } from "react";
import { Table, Input, Button, Space, Popconfirm, message, Modal, Tooltip } from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { API_DELETE_STORE } from "api/store-managemnt"; // Import your API functions
import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import { API_LIST_MAIN_LAUNDRY } from "api/main-laundry-management";
import { API_DELETE_MAIN_LAUNDRY } from "api/main-laundry-management";
import EditLaundry from "views/admin/mainlaundryManagement/EditLaundry";
import ViewLaundry from "views/admin/mainlaundryManagement/ViewLaundry/ViewLaundry";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_DELETE_PLAN } from "api/plan-management";
import { API_LIST_PLAN } from "api/plan-management";
import EditPlan from "views/admin/planesManagement/EditPlan";
import ViewPlan from "views/admin/planesManagement/ViewPlan/ViewPlan";
const { Column } = Table;
const { TextArea } = Input;
const PlanTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_PLAN(params);
      console.log("provider", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData.total_plans }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    navigate(`/admin/plan-management/edit/${record._id}`, {
      state: { data: record },
    });
  };

  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);
    navigate(`/admin/plan-management/${record._id}`, {
      state: { data: record },
    });
  };

  const handleDelete = async (id) => {
    try {
      let q = await API_DELETE_PLAN(id);
      message.success(q?.message);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting store:", error);
      message.error("Failed to delete store");
    }
  };

  const handleEditModalOk = () => {
    // Implement edit store logic here
    console.log("Editing store:", selectedStore);
    setEditModalVisible(false);
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };
  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  return (
    <div>
      <div className=" mb-4 flex justify-between">
        <Input
          className="border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
        />

        {/* <Link
          to={"/admin/plan-management/create-plan"}
          className="linear p-[4px 11px] flex w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200"
        >
          + {t("Create Plan")}
        </Link> */}
      </div>
      <Table
        dataSource={data?.plans}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id} // Assuming each record has a unique id
        rowClassName={getRowClassName} // Apply alternating row colors
        scroll={{ x: true }}
      >

        <Column title={t("Title")} dataIndex="plan_title" key="plan_title" width = '9rem'/>

        <Column
          title={t("Description")}
          dataIndex="plan_description"
          key="plan_description"
          width = '9rem'
          render = {(text)=> (
              <Tooltip title = {text}> 
                  {text.length > 20 ? `${text.substring(0,20)}...` : text}
              </Tooltip>
          )}
        />

        <Column title={t("Plan Type")} dataIndex="plan_type" key="plan_type" width = '9rem'/>
        <Column
          title={t("Discount Type")}
          dataIndex="discount_type"
          key="discount_type"
          width = '9rem'
          // render={(text, record) => <span>{record?.laundry?.[0]}</span>}
        />
        <Column
          title={t("Plan Discount")}
          dataIndex="plan_discount"
          key="plan_discount"
          width = '9rem'
          // render={(text, record) => <span>{record?.laundry?.[0]}</span>}
        />

        <Column
          title={t("Actions")}
          key="actions"
          width = '9rem'
          render={(text, record) => (
            <div>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              ></Button>
              {/* <Popconfirm
                title="Are you sure to delete this Plan?"
                onConfirm={() => handleDelete(record?._id)}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="danger"
                  icon={<DeleteOutlined />}
                  style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                ></Button>{" "}
              </Popconfirm> */}
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                style={{ marginLeft: "5px" }}
              ></Button>
            </div>
          )}
        />
      </Table>

      {/* Edit Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("Edit Plan")}
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "65rem" }}
      >
        <EditPlan data={selectedStore} />
      </Modal>

      {/* View Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("View Plan")}
        visible={viewModalVisible}
        onOk={handleViewModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "60rem" }}
      >
        <ViewPlan data={selectedStore} />
      </Modal>
    </div>
  );
};

export default PlanTable;
